export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/worker.0843d1a0.worker.js");
}
